<template>
  <el-dialog :visible="display" @open="open" @closed="closed" @close="$emit('close', false)" @opened="opened"
             destroy-on-close append-to-body :close-on-press-escape="false" :close-on-click-modal="false">
    <template #title>
      <h5>{{ dialogTitle }}</h5>
      <hr>
    </template>
    <el-row align="center">
      <el-col :span="20" :offset="2">
        <el-form label-position="left" label-width="80px">
          <el-form-item class="full-width" :label="$t('email.label.from')">
            <v-text-field ref="mailFrom" v-model="form.from" hide-details></v-text-field>
          </el-form-item>
          <el-form-item class="full-width" :label="$t('email.label.to')">
            <v-combobox ref="mailTo" :items="receivables" multiple v-model="form.to" :return-oject="false" hide-details>
              <template v-slot:item="scope">
                <span>{{ scope.item.name }}</span>
              </template>
              <template v-slot:selection="scope" v-bind="scope.attrs"
                        @click:close="scope.parent.selectItem(scope.item)">
                <v-chip small>
                  <v-avatar v-if="scope.item.photo" class="mr-1" left>
                    <v-img :src="scope.item.photo"></v-img>
                  </v-avatar>
                  <el-avatar class="mr-1 el-avatar-tiny" v-else>
                    <span v-if="typeof scope.item === 'string'">{{ scope.item.slice(0, 1).toUpperCase() }}</span>
                    <span v-else>{{ scope.item.name.slice(0, 1).toUpperCase() }}</span>
                  </el-avatar>
                  {{ scope.item.name }} &lt;{{ scope.item.email }}&gt;
                </v-chip>
              </template>
            </v-combobox>
          </el-form-item>
          <el-form-item class="full-width" :label="$t('email.label.cc')">
              <v-combobox ref="mailCc" :items="receivables" multiple v-model="form.cc" :return-oject="false" hide-details
                          @input="makeCcObject">
                <template v-slot:item="scope">
                  <span>{{ scope.item.name }}</span>
                </template>
                <template v-slot:selection="scope" v-bind="scope.attrs" @click:close="scope.parent.selectItem(scope.item)">
                  <v-chip small>
                    <v-avatar v-if="scope.item.photo" class="mr-1" left>
                      <v-img :src="scope.item.photo"></v-img>
                    </v-avatar>
                    <el-avatar class="mr-1 el-avatar-tiny" v-else>
                      <span v-if="typeof scope.item === 'string'">{{ scope.item.slice(0, 1).toUpperCase() }}</span>
                      <span v-else>{{ scope.item.name.slice(0, 1).toUpperCase() }}</span>
                    </el-avatar>
                    {{ scope.item.name }} &lt;{{ scope.item.email }}&gt;
                  </v-chip>
                </template>
              </v-combobox>
          </el-form-item>
          <el-form-item class="full-width" :label="$t('email.label.subject')">
            <v-text-field ref="mailSubject" v-model="form.subject"></v-text-field>
          </el-form-item>
          <el-form-item class="full-width" :label="$t('email.label.message')">
            <v-textarea ref="mailBody" v-model="form.body" :rows="3" hide-details></v-textarea>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12" :offset="4" v-show="form.attachments.length > 0">
        <h6 class="mb-1">{{ $t('email.label.attachment') }}:</h6>
        <v-chip class="mx-1 my-1" close v-for="attach in form.attachments" :key="attach.code">
          <v-avatar left>
            <v-icon color="orange">mdi-file-pdf</v-icon>
          </v-avatar>
          {{ attach.code }}
        </v-chip>
      </el-col>
    </el-row>
    <template #footer>
      <el-row class="dialog-footer">
        <el-col :span="12" :offset="6">
          <el-button :loading="loading" @click="$emit('close', false)" type="danger" plain>
            {{ $t('button.cancel') }}
          </el-button>
          <el-button type="primary" :loading="loading" icon="el-icon-arrow-right" @click.prevent="sendEmail">
            {{ $t('supply.button.send') }}
          </el-button>
        </el-col>
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'EmailDialog',
  props: {
    display: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    to: {
      type: Array,
      default: () => ([])
    },
    from: {
      type: String,
      default: ''
    },
    cc: {
      type: Array,
      default: () => ([])
    },
    attachments: {
      type: Array,
      default: () => ([])
    },
    subject: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: ''
    },
    po: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dialogTitle: '',
      receivables: [],
      form: {
        to: [],
        cc: [],
        from: [],
        attachments: [],
        subject: '',
        body: ''
      },
      loading: false
    }
  },
  watch: {
    'form.to' (curr, prev) {
      if (curr.length > prev.length) { // added value
        if (this.form.to.some((v) => typeof v === 'string')) {
          const index = this.form.to.indexOf(this.form.to.find(v => typeof v === 'string'))
          const [email] = this.form.to.splice(index, 1)
          if (/^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/.test(email)) {
            const data = {
              email: email,
              name: email.substring(0, email.indexOf('@')),
              photoType: 'icon'
            }
            this.form.to.push(data)
          }
        }
      }
    }
  },
  methods: {
    open () {
    },
    opened () {
      this.dialogTitle = this.title || this.$t('email.title.generic')
      this.$userService.getUsers()
        .then(users => {
          users.forEach(user => {
            if (user.email) {
              this.receivables.push({
                name: user.name,
                email: user.email,
                photo: user.photo,
                photoType: 'photo'
              })
            }
          })
        })
      this.$supplierService.getSuppliers()
        .then(suppliers => {
          suppliers.forEach(supplier => {
            if (supplier.email) {
              this.receivables.push({
                name: supplier.name,
                email: supplier.email,
                photo: 'mdi mdi-account',
                photoType: 'icon'
              })
            }
          })
        })
      this.$customerService.getCustomers()
        .then(customers => {
          customers.forEach(customer => {
            if (customer.email) {
              this.receivables.push({
                name: customer.name,
                email: customer.email,
                photo: customer.photo,
                photoType: 'photo'
              })
            }
          })
        })
      if (this.to.length) {
        this.form.to = this.to.map(t => ({
          name: t.name,
          email: t.email,
          photo: t.photo,
          ...t
        }))
      }
      if (this.from.length) {
        this.form.from = this.from
      }
      if (this.cc.length) {
        this.form.cc = this.cc.map(t => ({
          name: t.name,
          email: t.email,
          photo: t.photo,
          ...t
        }))
      }
      if (this.attachments.length) {
        this.form.attachments = this.attachments // .map(t => ({}))
      }
      if (this.subject.length) {
        this.form.subject = this.subject
      }
      if (this.body.length) {
        this.form.body = this.body
      }
      this.$nextTick(this.$refs.mailBody.focus)
    },
    closed () {
      Object.keys(this.form).forEach((k, i) => {
        if (typeof this.form[k] === 'string') {
          this.form[k] = ''
        } else if (typeof this.form[k] === 'object') {
          this.form[k] = []
        }
      })
    },
    makeCcObject (val) {
      const email = val[0]
      if (typeof email === 'string') {
        const index = this.form.cc.indexOf(this.form.cc.find(v => typeof v === 'string'))
        const [email] = this.form.cc.splice(index, 1)
        if (/^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/.test(email)) {
          console.log('Is email: ', email)
          const data = {
            email: email,
            name: email.substring(0, email.indexOf('@')),
            photoType: 'icon'
          }
          this.form.cc.push(data)
        } else {
        }
      }
    },
    validInput () {
      for (const v of ['from', 'to', 'subject', 'body']) {
        if (!this.form[v].length) {
          this.notify(this.$t('supply.message.email_field_empty', { field: v }), this.$t('status.validation'), 'error')
          console.log(this.$refs[`mail${v.charAt(0).toUpperCase().concat(v.substring(1))}`])
          this.$nextTick(this.$refs[`mail${v.charAt(0).toUpperCase().concat(v.substring(1))}`].focus)

          return false
        }
      }
      return true
    },
    async sendEmail () {
      if (this.validInput()) {
        this.loading = true
        this.$supplyService.sendEmail(this.form)
          .then(_ => {
            this.displayMessage(this.$t('supply.message.email_success'))
            this.$emit('close')
          })
          .catch(_ => {})
          .then(_ => {
            this.loading = false
          })
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.el-avatar-tiny {
  width: 21px;
  height: 21px;
  line-height: 21px;
}
</style>
